/**
 * @description unit-list model
 * @date 2019-03-29
 * @author jywang
 */
import React, { PureComponent } from 'react';
import { QUESTION_STATUS } from '../../enum';
import './index.scss';
class UnitLi extends PureComponent<any, any> {
    public render() {
        const {questionProductId, imageUrls, surfacePlot, title, answerSum, collectSum, releaseTime, id, description, browseSum, favourSum, commentSum, shareSum, status, avatar, nickname, delQuestion, auditDescription } = this.props;
        const hasShowImg = imageUrls.length > 0 || surfacePlot;
        return (
            <div className="question-unit-li-box">
                <h3><a href={`/question/detail/${questionProductId}`}>{substrTit(title)}</a></h3>
                <div className="topSign">
                    <p className="question-top-tag">
                        <span className="answer-tag"><i>答</i>{answerSum}</span>
                    </p>
                    <p className="userName">
                        <span className="avatar-tag">
                            <i>
                                <img src={avatar || require('../../../../assets/images/commonImg/personIco.jpg')} alt="" />
                            </i>
                            {nickname}
                        </span>{
                            // tslint:disable-next-line: jsx-no-lambda
                            <span onClick={() => delQuestion(id)}>删除</span>}
                    </p>
                </div>
                <a href={`/question/detail/${id}`} className="img-desc-box">
                    <span className="questionImg" hidden={!hasShowImg}>
                        <img src={imageUrls.length > 0 ? imageUrls[0]['imageUrl'] : surfacePlot} alt="" />
                    </span>
                    <p>{substrTit(description)}</p>
                </a>
                <div className="bottomSign">
                    <p className="questStatus" style={status === 1 ? { color: '#FF8800' } : status === 3 ? { color: '#FF3B30' } : status === 2 ? { color: '#B1B1B1' } : { color: '#222222' }}>{QUESTION_STATUS[status]}{status === 3 && ':' + auditDescription}</p>
                    <p className="question-bottom-tag">
                        <span>{releaseTime}</span>
                        <span className="examine-tag">
                            <i>
                                <img src={require('../../../../assets/images/commonImg/readIco.png')} alt="" />
                            </i>
                            {browseSum}
                        </span>
                        <span className="like-tag">
                            <i>
                                <img src={require('../../../../assets/images/commonImg/likeIco.png')} alt="" />
                            </i>
                            {favourSum}
                        </span>
                        <span className="comment-tag">
                            <i>
                                <img src={require('../../../../assets/images/commonImg/infoIco.png')} alt="" />
                            </i>
                            {commentSum}
                        </span>
                        <span className="share-tag">
                            <i>
                                <img src={require('../../../../assets/images/commonImg/shareico.jpg')} alt="" />
                            </i>
                            {shareSum}
                        </span>
                    </p>
                </div>
            </div>
        );
    }
}
export default UnitLi;

function substrTit(title) {
    if (title.length > 113) {
        return title.substr(0, 113) + '...';
    }
    return title;
}
